import { render } from "./AudioBlock.vue?vue&type=template&id=23931108&scoped=true"
import script from "./AudioBlock.vue?vue&type=script&lang=js"
export * from "./AudioBlock.vue?vue&type=script&lang=js"

import "./AudioBlock.vue?vue&type=style&index=0&id=23931108&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23931108"]])

export default __exports__